import React from 'react';

const Notification = ({ notification }) => {
  if (!notification) return null;
  
  return (
    <div className={`notification ${notification.type}`}>
      <p className="notification-message">{notification.message}</p>
    </div>
  );
};

export default Notification; 